/* LX layer — cart drawer, quick add, product page, bundles, rails, search, collection filtering. */
(() => {
  'use strict';
  const LX = (window.LX = window.LX || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const CART_SECTION = 'lx-cart-drawer';

  // ------------------------------------------------------------------ utils
  function money(cents) {
    const fmt = LX.moneyFormat || '${{amount}}';
    const n = Number(cents || 0) / 100;
    const two = (sep, dec) => { const [a, b] = n.toFixed(2).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + dec + b; };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return two('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return two(',', '.');
    });
  }
  LX.money = money;
  const T = (k, fallback) => (LX.t && LX.t[k]) || fallback;
  const fill = (str, map) => String(str).replace(/\[(\w+)\]/g, (m, k) => (map[k] !== undefined ? map[k] : m));
  function tierState(count) {
    const tiers = (LX.tiers || []).slice().sort((a, b) => a.q - b.q);
    if (!tiers.length) return null;
    let current = 0, done = 0, prevQ = 0, next = null;
    for (const t of tiers) { if (count >= t.q) { current = t.p; done++; prevQ = t.q; } else if (!next) next = t; }
    const progress = next ? (done + Math.max(0, count - prevQ) / (next.q - prevQ)) / tiers.length : 1;
    return { tiers, current, next, progress, need: next ? next.q - count : 0 };
  }
  // Buy X, get Y free: every (X+Y)th piece is free; Shopify discounts the lowest-priced pieces.
  function bxState(count) {
    const o = LX.offer || {}; const buy = Number(o.buy) || 2, get = Number(o.get) || 1, group = buy + get;
    const sets = Math.floor(count / group); const capped = o.repeat === false && sets >= 1;
    const free = capped ? get : sets * get; const r = count % group;
    const filled = r === 0 && count > 0 ? group : r;
    return { buy, get, group, free, capped, filled, need: group - r, progress: filled / group };
  }
  const freeCount = (n) => bxState(n).free;
  const freeValue = (prices) => { const f = freeCount(prices.length); return prices.slice().sort((a, b) => a - b).slice(0, f).reduce((t, p) => t + p, 0); };
  LX.bxState = bxState;
  function paintBx(el, count) {
    const st = bxState(count);
    const word = (k) => (k === 1 ? T('piece', 'piece') : T('pieces', 'pieces'));
    const msg = st.capped ? T('bxMax', 'Your free piece is unlocked!')
      : st.free > 0 ? fill(T('bxDone', '[free] free [freeword] unlocked! Add [n] more [pieces] for another.'), { free: st.free, freeword: word(st.free), n: st.need, pieces: word(st.need) })
      : fill(T('bxNeed', 'Add [n] more [pieces] to get [get] free'), { n: st.need, pieces: word(st.need), get: st.get });
    const m = el.querySelector('[data-lx-tiers-msg]'); if (m && m.textContent !== msg) m.textContent = msg;
    const fl = el.querySelector('[data-lx-tiers-fill]'); if (fl) fl.style.setProperty('--p', st.group > 1 ? Math.max(0, st.filled - 1) / (st.group - 1) : 1);
    const cta = el.querySelector('[data-lx-tiers-cta]'); if (cta) cta.hidden = st.capped;
    const now = el.querySelector('[data-lx-tiers-now]'); if (now) { now.hidden = !st.free; now.textContent = st.free + ' ' + T('bxFree', 'Free').toLowerCase(); }
    el.querySelectorAll('.lx-tiers__step').forEach((x) => { const i = Number(x.dataset.i); x.classList.toggle('is-on', i <= st.filled); x.classList.toggle('is-next', i === st.filled + 1); });
    const was = Number(el.dataset.pct || 0); el.dataset.pct = st.free; el.classList.toggle('is-max', st.capped);
    if (st.free > was && el._painted) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    el._painted = true;
    return st;
  }
  function paintTiers(el, count) {
    if (el && el.dataset.offer === 'bxgy') return paintBx(el, count);
    const st = tierState(count); if (!el || !st) return null;
    const word = st.need === 1 ? T('piece', 'piece') : T('pieces', 'pieces');
    const msg = st.next ? fill(T('tierNext', 'Add [n] more [pieces] to unlock [pct]% off your entire order'), { n: st.need, pieces: word, pct: st.next.p }) : fill(T('tierMax', "You've unlocked [pct]% off your entire order"), { pct: st.current });
    const m = el.querySelector('[data-lx-tiers-msg]'); if (m && m.textContent !== msg) m.textContent = msg;
    const fl = el.querySelector('[data-lx-tiers-fill]'); if (fl) fl.style.setProperty('--p', st.progress);
    const now = el.querySelector('[data-lx-tiers-now]'); if (now) { now.hidden = !st.current; now.textContent = '\u2212' + st.current + '%'; }
    let nextSet = false;
    el.querySelectorAll('.lx-tiers__step').forEach((x) => { const on = count >= Number(x.dataset.q); x.classList.toggle('is-on', on); const nx = !on && !nextSet; if (nx) nextSet = true; x.classList.toggle('is-next', nx); });
    const was = Number(el.dataset.pct || 0); el.dataset.pct = st.current; el.classList.toggle('is-max', !st.next);
    if (st.current > was && was >= 0 && el._painted) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    el._painted = true;
    return st;
  }
  LX.tierState = tierState;
  function confetti(host) {
    if (!LX.confetti || !host || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const box = document.createElement('div'); box.className = 'lx-confetti'; box.setAttribute('aria-hidden', 'true');
    const colors = ['#c9a45c', '#e8d29a', '#b9bec6', '#19110b', '#efe6d6'];
    for (let i = 0; i < 28; i++) { const p = document.createElement('i'); p.style.setProperty('--x', (Math.random() * 2 - 1).toFixed(2)); p.style.setProperty('--d', (0.6 + Math.random() * 0.7).toFixed(2) + 's'); p.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg'); p.style.left = 30 + Math.random() * 40 + '%'; p.style.background = colors[i % colors.length]; box.appendChild(p); }
    host.appendChild(box); setTimeout(() => box.remove(), 1500);
  }
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const imgW = (url, w) => { if (!url) return url; try { const u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; } };
  const icon = (name) => ({
    plus: '<svg class="lx-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 4v16M4 12h16"/></svg>',
    check: '<svg class="lx-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    close: '<svg class="lx-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg>',
  }[name]);

  // ------------------------------------------------------------------ toast
  let toastT;
  function toast(msg) {
    const el = $('[data-lx-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('is-on'), 3200);
  }
  LX.toast = toast;

  // ------------------------------------------------------------------ drawers
  let openName = null, lastFocus = null;
  const overlay = () => $('[data-lx-overlay]');
  function openDrawer(name) {
    const el = $(`[data-lx-drawer="${name}"]`); if (!el) return false;
    if (openName && openName !== name) closeDrawer(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    // drawers that live in the sticky header (menu, search) need the header above the page overlay
    document.body.classList.toggle('lx-head-open', !!el.closest('#header-group'));
    overlay() && overlay().classList.add('is-open');
    document.body.classList.add('lx-lock');
    openName = name;
    setTimeout(() => { const f = el.querySelector(name === 'search' ? 'input[type=search]' : 'button, a[href], input, select, textarea'); (f || el).focus({ preventScroll: true }); }, 60);
    return true;
  }
  function closeDrawer(keepOverlay) {
    if (!openName) return;
    const el = $(`[data-lx-drawer="${openName}"]`);
    el && el.classList.remove('is-open');
    document.body.classList.remove('lx-head-open');
    openName = null;
    if (!keepOverlay) { overlay() && overlay().classList.remove('is-open'); document.body.classList.remove('lx-lock'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  }
  LX.open = openDrawer; LX.close = closeDrawer;
  document.addEventListener('click', (e) => {
    const op = e.target.closest('[data-lx-open]');
    if (op) {
      const name = op.getAttribute('data-lx-open');
      if (name === 'cart' && LX.cartType === 'page') return;
      if ($(`[data-lx-drawer="${name}"]`)) { e.preventDefault(); openDrawer(name); }
      return;
    }
    if (e.target.closest('[data-lx-close]') || e.target.closest('[data-lx-overlay]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { if ($('[data-lx-zoom].is-open')) closeZoom(); else closeDrawer(); }
    if (e.key === 'Tab' && openName) {
      const el = $(`[data-lx-drawer="${openName}"]`); if (!el) return;
      const f = $$('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter((x) => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // ------------------------------------------------------------------ cart
  const cartPageSection = () => { const el = $('[data-lx-cartpage]'); return el ? el.closest('.shopify-section')?.id.replace('shopify-section-', '') : null; };
  function sectionsParam() { const s = [CART_SECTION]; const p = cartPageSection(); if (p) s.push(p); return s; }
  // Express wallets the merchant switched off (Theme settings > LX · Brand & cart) are removed from Shopify's
  // accelerated-checkout config, so the remaining buttons share one row instead of stacking.
  function walletCfg(el) {
    const hide = LX.hideWallets || [];
    if (!hide.length) return null;
    try {
      const cfg = JSON.parse(el.getAttribute('wallet-configs') || '[]');
      const keep = cfg.filter((w) => !hide.includes(w.name));
      return keep.length === cfg.length ? null : JSON.stringify(keep);
    } catch (e) { return null; }
  }
  function trimWallets(root, detached) {
    $$('shopify-accelerated-checkout-cart', root).forEach((el) => {
      const cfg = walletCfg(el);
      if (!cfg) return;
      if (detached) { el.setAttribute('wallet-configs', cfg); el.innerHTML = ''; return; }
      const n = el.cloneNode(false); n.setAttribute('wallet-configs', cfg); el.replaceWith(n);
    });
  }
  function renderSections(sections) {
    if (!sections) return;
    const bagBody = $('[data-lx-cart-inner] [data-lx-bag-body]');
    const bagTop = bagBody ? bagBody.scrollTop : 0;
    const oldPct = Number(($('[data-lx-cart-inner] [data-lx-tiers]') || {}).dataset?.pct || 0);
    const html = sections[CART_SECTION];
    if (html) {
      const doc = parse(html);
      const inner = $('[data-lx-cart-inner]', doc);
      const cur = $('[data-lx-cart-inner]');
      if (inner) trimWallets(inner, true);
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      const json = $('[data-lx-cart-json]', doc);
      if (json) { try { const j = JSON.parse(json.textContent); LX.cartCount = j.item_count; LX.cartPrices = j.prices || []; LX.protectIn = !!j.protect_in; LX.protectOff = !!j.protect_off; updateCount(j.item_count); } catch (e) {} }
      const nt = $('[data-lx-cart-inner] [data-lx-tiers]');
      const newPct = Number(nt?.dataset.pct || 0);
      const nb = $('[data-lx-cart-inner] [data-lx-bag-body]');
      if (nt && newPct > oldPct) { nt.classList.add('is-pop'); toast(nt.dataset.offer === 'bxgy' ? T('bxWon', 'Free piece unlocked!') : fill(T('tierWon', '[pct]% off unlocked!'), { pct: newPct })); confetti($('#lx-cart')); if (nb) nb.scrollTop = 0; }
      else if (nb) nb.scrollTop = bagTop;
      $$('[data-lx-bundle]').forEach((b) => b._sync && b._sync());
    }
    const p = cartPageSection();
    if (p && sections[p]) { const doc = parse(sections[p]); const n = $('[data-lx-cart-page-inner]', doc); const c = $('[data-lx-cart-page-inner]'); if (n) trimWallets(n, true); if (n && c) c.innerHTML = n.innerHTML; }
    requestAnimationFrame(() => { $$('.lx-progress__bar span').forEach((s) => { s.style.transition = 'none'; const v = s.style.getPropertyValue('--p'); s.style.setProperty('--p', 0); s.offsetWidth; s.style.transition = ''; s.style.setProperty('--p', v); }); });
    if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (e) {} }
    ensureProtect();
  }
  // Shipping protection: added automatically while the bag has pieces (unless the customer switched it off for this
  // cart) and removed when the bag has no pieces left.
  let protectBusy = false, protectFails = 0;
  const protectWanted = () => { const P = LX.protect; return !!(P && P.on && P.auto && P.available && !LX.protectOff && protectFails < 2); };
  async function ensureProtect() {
    const P = LX.protect; if (!P || protectBusy) return;
    const n = LX.cartCount || 0;
    let qty = null;
    if (n > 0 && !LX.protectIn && protectWanted()) qty = 1;
    else if (n === 0 && LX.protectIn) qty = 0;
    if (qty === null) return;
    protectBusy = true;
    try { const data = await post(LX.routes.cartUpdate + '.js', { updates: { [P.variant]: qty }, sections: sectionsParam(), sections_url: location.pathname }); LX.protectIn = qty > 0; renderSections(data.sections); }
    catch (e) { protectFails++; }
    finally { protectBusy = false; }
  }
  // "Choose a piece": jump to the suggestions in the bag / on the cart page
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-lx-tiers-cta]'); if (!a) return;
    const box = a.closest('[data-lx-cart-inner], [data-lx-cart-page-inner]') || document;
    const up = box.querySelector('[data-lx-upsell]'); if (!up) return;
    e.preventDefault(); up.scrollIntoView({ behavior: 'smooth', block: 'start' });
    up.classList.remove('is-flash'); void up.offsetWidth; up.classList.add('is-flash');
  });
  document.addEventListener('change', async (e) => {
    const t = e.target.closest('[data-lx-protect]'); if (!t) return;
    const on = t.checked; t.disabled = true;
    try {
      const data = await post(LX.routes.cartUpdate + '.js', { updates: { [t.dataset.lxProtect]: on ? 1 : 0 }, attributes: { _lx_protect: on ? '' : 'off' }, sections: sectionsParam(), sections_url: location.pathname });
      LX.protectOff = !on; LX.protectIn = on; renderSections(data.sections);
    } catch (err) { t.checked = !on; toast(err.message); }
    finally { t.disabled = false; }
  });
  function updateCount(n) {
    $$('[data-lx-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); });
    $$('[data-lx-open="cart"]').forEach((a) => a.setAttribute('aria-label', `Bag, ${n} items`));
  }
  async function post(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.description || data.message || 'Something went wrong'), { data });
    return data;
  }
  async function add(items, opts = {}) {
    try {
      const withP = !LX.protectIn && protectWanted() && !items.some((i) => Number(i.id) === LX.protect.variant);
      let data;
      try { data = await post(LX.routes.cartAdd + '.js', { items: withP ? [...items, { id: LX.protect.variant, quantity: 1 }] : items, sections: sectionsParam(), sections_url: location.pathname }); if (withP) LX.protectIn = true; }
      catch (e) { if (!withP) throw e; protectFails++; data = await post(LX.routes.cartAdd + '.js', { items, sections: sectionsParam(), sections_url: location.pathname }); }
      document.dispatchEvent(new CustomEvent('lx:cart:added', { detail: data }));
      if (LX.cartType === 'page' && !cartPageSection()) { location.href = LX.routes.cart; return data; }
      renderSections(data.sections);
      if (opts.open !== false) openDrawer('cart');
      return data;
    } catch (err) { toast(err.message); throw err; }
  }
  async function change(key, quantity) {
    const line = $(`[data-lx-line="${CSS.escape(key)}"]`); line && line.classList.add('is-busy');
    try { const data = await post(LX.routes.cartChange + '.js', { id: key, quantity, sections: sectionsParam(), sections_url: location.pathname }); renderSections(data.sections); }
    catch (err) { toast(err.message); line && line.classList.remove('is-busy'); }
  }
  LX.add = add; LX.change = change;
  const saveNote = debounce(async (note, el) => {
    try { await post(LX.routes.cartUpdate + '.js', { note }); const s = el.closest('details')?.querySelector('[data-lx-note-saved]'); if (s) { s.classList.add('is-on'); setTimeout(() => s.classList.remove('is-on'), 1500); } } catch (e) {}
  }, 600);
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-lx-qty]');
    if (q) { const line = q.closest('[data-lx-line]'); if (line) { e.preventDefault(); change(line.dataset.lxLine, Math.max(0, parseInt(q.dataset.lxQty, 10) || 0)); } }
  });
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-lx-qty-input]');
    if (inp) { const line = inp.closest('[data-lx-line]'); if (line) change(line.dataset.lxLine, Math.max(0, parseInt(inp.value, 10) || 0)); }
  });
  document.addEventListener('input', (e) => { const n = e.target.closest('[data-lx-note]'); if (n) saveNote(n.value, n); });
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-lx-addform]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'); btn && btn.classList.add('is-loading');
    try { await add([{ id: Number(new FormData(f).get('id')), quantity: 1 }], { open: true }); } catch (err) {}
    btn && btn.classList.remove('is-loading');
  });

  // ------------------------------------------------------------------ product cards: dots + quick add
  const cardData = (card) => { if (!card._lx) { try { card._lx = JSON.parse(card.querySelector('[data-lx-product]').textContent); } catch (e) { card._lx = null; } } return card._lx; };
  const finishMedia = (data, finish) => (data.media || []).filter((m) => m.alt && m.alt.includes(` – ${finish} – `));
  function swapImg(img, src) { if (!img || !src) return; img.removeAttribute('srcset'); img.src = src; }
  document.addEventListener('click', async (e) => {
    const dot = e.target.closest('[data-lx-dot]');
    if (dot) {
      e.preventDefault();
      const card = dot.closest('[data-lx-card]'); const data = cardData(card); if (!data) return;
      const fin = dot.dataset.lxDot;
      $$('[data-lx-dot]', card).forEach((d) => d.classList.toggle('is-active', d === dot));
      const fm = finishMedia(data, fin); const a = fm[0]; const b = fm[1];
      swapImg(card.querySelector('[data-lx-img="a"]'), a && a.src); swapImg(card.querySelector('[data-lx-img="b"]'), b && b.src);
      const fi = data.options.indexOf('Finish'); const v = data.variants.find((x) => x.o[fi] === fin && x.a) || data.variants.find((x) => x.o[fi] === fin);
      if (v) $$('a[href]', card).forEach((l) => { l.href = `${data.url}?variant=${v.id}`; });
      card.dataset.finish = fin;
      return;
    }
    const qa = e.target.closest('[data-lx-quick]');
    if (qa) {
      e.preventDefault();
      if (qa.dataset.variant) {
        qa.classList.add('is-loading');
        try { await add([{ id: Number(qa.dataset.variant), quantity: 1 }]); qa.classList.add('is-done'); qa.innerHTML = icon('check'); setTimeout(() => { qa.classList.remove('is-done'); qa.innerHTML = icon('plus'); }, 1800); } catch (err) {}
        qa.classList.remove('is-loading');
      } else {
        const card = qa.closest('[data-lx-card]'); const data = cardData(card); if (data) openQuick(data, card.dataset.finish);
      }
    }
  });

  // quick sheet
  function variantFor(data, sel) { return data.variants.find((v) => v.o.every((x, i) => x === sel[i])); }
  function priceHtml(v) {
    if (!v) return '';
    return v.c > v.p ? `<span class="lx-price"><span class="lx-price__sale">${money(v.p)}</span><s>${money(v.c)}</s><span class="lx-price__save">Save ${money(v.c - v.p).replace(/\.00$/, '')}</span></span>` : `<span class="lx-price"><span>${money(v.p)}</span></span>`;
  }
  function openQuick(data, preferFinish) {
    const body = $('[data-lx-quick-body]'); if (!body) return;
    const fi = data.options.indexOf('Finish');
    let start = data.variants.find((v) => v.a && (fi < 0 || !preferFinish || v.o[fi] === preferFinish)) || data.variants[0];
    const sel = start.o.slice();
    const opts = data.options.map((name, i) => {
      const vals = [...new Set(data.variants.map((v) => v.o[i]))];
      return `<fieldset class="lx-opt" data-i="${i}"><legend class="lx-sr">${esc(name)}</legend><div class="lx-opt__label"><span><b>${esc(name === 'Finish' ? 'Color' : name)}:</b><em data-lx-q-val>${esc(sel[i])}</em></span></div><div class="lx-opt__values">${vals.map((val, j) => {
        const id = `lxq-${data.id}-${i}-${j}`;
        const lab = name === 'Finish' ? `<label class="lx-swatch" for="${id}" title="${esc(val)}"><i class="lx-sw-${esc(val.toLowerCase())}"></i><span>${esc(val)}</span></label>` : `<label class="lx-pill" for="${id}">${esc(val)}</label>`;
        return `<input type="radio" id="${id}" name="lxq-${i}" value="${esc(val)}"${val === sel[i] ? ' checked' : ''}>${lab}`;
      }).join('')}</div></fieldset>`;
    }).join('');
    body.innerHTML = `<div style="display:grid;grid-template-columns:minmax(0,1fr);gap:0">
      <div style="display:grid;grid-template-columns:120px 1fr;gap:16px;padding:18px 20px 0;align-items:start" class="lx-quick-top">
        <div class="lx-media" style="--ratio:1/1"><img data-lx-q-img src="${esc(imgW(start.img || (data.media[0] && data.media[0].src), 400))}" alt=""></div>
        <div><p class="lx-eyebrow" style="margin:0 0 6px">${esc(data.type || '')}</p><p class="lx-h3" style="margin:0 0 8px">${esc(data.title)}</p><div data-lx-q-price>${priceHtml(start)}</div>
        <a class="lx-link" style="display:inline-block;margin-top:12px" href="${esc(data.url)}">${esc(T('details', 'Full details'))}</a></div>
        <button type="button" class="lx-icon-btn" data-lx-close aria-label="Close" style="position:absolute;top:6px;right:6px">${icon('close')}</button>
      </div>
      <div style="padding:20px">${data.options.length === 1 && data.options[0] === 'Title' ? '' : opts}
        <button type="button" class="lx-btn lx-btn--block" data-lx-q-add>${esc(T('addBag', 'Add to bag'))}</button></div></div>`;
    const sync = () => {
      const v = variantFor(data, sel);
      $('[data-lx-q-price]', body).innerHTML = priceHtml(v);
      const b = $('[data-lx-q-add]', body); b.disabled = !v || !v.a; b.textContent = !v ? T('unavailable', 'Unavailable') : v.a ? `${T('addBag', 'Add to bag')} — ${money(v.p)}` : T('sold', 'Sold out');
      if (v && v.img) $('[data-lx-q-img]', body).src = imgW(v.img, 400);
      $$('fieldset', body).forEach((fs) => { const i = +fs.dataset.i; const em = $('[data-lx-q-val]', fs); if (em) em.textContent = sel[i]; });
      $$('fieldset', body).forEach((fs) => { const i = +fs.dataset.i; $$('input', fs).forEach((inp) => { const t = sel.slice(); t[i] = inp.value; const vv = variantFor(data, t); inp.classList.toggle('is-unavailable', !vv || !vv.a); }); });
    };
    body.onchange = (e) => { const fs = e.target.closest('fieldset'); if (!fs) return; sel[+fs.dataset.i] = e.target.value; sync(); };
    body.onclick = async (e) => {
      const b = e.target.closest('[data-lx-q-add]'); if (!b) return;
      const v = variantFor(data, sel); if (!v) return;
      b.classList.add('is-loading');
      try { closeDrawer(true); await add([{ id: v.id, quantity: 1 }]); } catch (err) { openDrawer('quick'); }
      b.classList.remove('is-loading');
    };
    sync();
    openDrawer('quick');
  }
  LX.openQuick = openQuick;

  // ------------------------------------------------------------------ bundles (PDP "complete the look" + shop the look)
  function bundleInit(root) {
    if (root._lx) return; root._lx = true;
    const rows = () => $$('[data-lx-bundle-row]', root);
    const priceOf = (row) => {
      if (row.hasAttribute('data-main')) return Number($('[data-lx-bundle-price]', row).dataset.lxBundlePrice);
      const s = $('[data-lx-bundle-select]', row);
      if (s.tagName === 'SELECT') return Number(s.selectedOptions[0].dataset.price);
      return Number(s.dataset.price);
    };
    const sync = () => {
      let total = 0, n = 0;
      rows().forEach((r) => {
        const p = priceOf(r); const pe = $('[data-lx-bundle-price]', r); if (pe && !r.hasAttribute('data-main')) pe.textContent = money(p);
        if ($('[data-lx-bundle-check]', r).checked) { total += p; n++; }
        r.classList.toggle('is-on', $('[data-lx-bundle-check]', r).checked);
      });
      const ladder = $('[data-lx-tiers]', root);
      const st = ladder ? paintTiers(ladder, (LX.cartCount || 0) + n) : null;
      const bx = ladder && ladder.dataset.offer === 'bxgy';
      const pct = st && !bx ? st.current : 0;
      let save = 0, newFree = 0;
      if (bx) {
        const sel = []; rows().forEach((r) => { if ($('[data-lx-bundle-check]', r).checked) sel.push(priceOf(r)); });
        const cartP = (LX.cartPrices || []).map(Number);
        save = freeValue(cartP.concat(sel)) - freeValue(cartP);
        newFree = freeCount(cartP.length + sel.length) - freeCount(cartP.length);
      } else save = Math.round(total * pct / 100);
      const was = $('[data-lx-bundle-was]', root);
      if (was) { was.hidden = !(save > 0 && n > 0); was.textContent = money(total); }
      $('[data-lx-bundle-total]', root).textContent = money(total - save);
      $('[data-lx-bundle-count]', root).textContent = fill(T('totalN', 'Total for [n] pieces'), { n }).replace(/\b1 pieces\b/, '1 ' + T('piece', 'piece'));
      const b = $('[data-lx-bundle-add]', root); b.disabled = n === 0;
      b.textContent = n === 0 ? T('select', 'Select a piece') : newFree > 0 ? fill(T('bxBtn', 'Add [n] pieces · [free] free'), { n, free: newFree }) : pct > 0 ? fill(T('tierBtn', 'Add [n] pieces · Save [pct]%'), { n, pct }) : fill(T('addN', 'Add [n] pieces to bag'), { n }).replace(/\b1 pieces\b/, '1 ' + T('piece', 'piece'));
    };
    root.addEventListener('change', sync);
    // tap anywhere on a suggestion to add / remove it
    root.addEventListener('click', (e) => {
      const row = e.target.closest('[data-lx-bundle-row]');
      if (!row || e.target.closest('a, select, input, label, button')) return;
      const cb = $('[data-lx-bundle-check]', row); cb.checked = !cb.checked; sync();
    });
    root._sync = sync;
    $('[data-lx-bundle-add]', root).addEventListener('click', async (e) => {
      const b = e.currentTarget; const items = [];
      rows().forEach((r) => {
        if (!$('[data-lx-bundle-check]', r).checked) return;
        if (r.hasAttribute('data-main')) { const id = $('[data-lx-variant-id]'); if (id) items.push({ id: Number(id.value), quantity: 1 }); }
        else items.push({ id: Number($('[data-lx-bundle-select]', r).value), quantity: 1 });
      });
      if (!items.length) return;
      b.classList.add('is-loading');
      try { await add(items); } catch (err) {}
      b.classList.remove('is-loading');
    });
    sync();
  }

  // ------------------------------------------------------------------ product page
  function pdpInit(root) {
    if (root._lx) return; root._lx = true;
    let data; try { data = JSON.parse($('[data-lx-pdp-json]', root).textContent); } catch (e) { return; }
    const form = $('[data-lx-pdp-form]', root);
    const idInput = $('[data-lx-variant-id]', root);
    const fi = data.options.indexOf('Finish');
    let current = data.variants.find((v) => String(v.id) === idInput.value) || data.variants[0];
    const sel = current.o.slice();
    const track = $('[data-lx-gallery-track]', root);
    const countEl = $('[data-lx-gallery-count]', root);
    const thumbsEl = $('[data-lx-thumbs]', root);
    const atc = $('[data-lx-atc]', root);
    const atcLabel = $('[data-lx-atc-label]', root);
    const baseLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to bag';
    const qtyInput = $('[data-lx-pdp-qty]', root);
    const slides = () => (track ? $$('.lx-gallery__slide', track).filter((x) => !x.hidden) : []);
    const thumbs = () => (thumbsEl ? $$('.lx-thumb', thumbsEl).filter((x) => !x.hidden) : []);
    const activeIndex = () => (track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0);
    function syncPosition() {
      const n = slides().length; const i = Math.min(activeIndex(), Math.max(0, n - 1));
      if (countEl) countEl.textContent = n > 1 ? `${i + 1}/${n}` : '';
      thumbs().forEach((t, j) => { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      const at = thumbs()[i]; if (at && thumbsEl) { const l = at.offsetLeft - thumbsEl.clientWidth / 2 + at.clientWidth / 2; thumbsEl.scrollTo({ left: Math.max(0, l), behavior: 'smooth' }); }
    }
    track && track.addEventListener('scroll', debounce(syncPosition, 40), { passive: true });
    thumbsEl && thumbsEl.addEventListener('click', (e) => {
      const t = e.target.closest('.lx-thumb'); if (!t) return;
      const i = thumbs().indexOf(t); if (i < 0 || !track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setTimeout(syncPosition, 450);
    });
    // finish filter shared by gallery, thumbnails and "see it styled"
    function filterByFinish(fin) {
      const groups = [$$('.lx-gallery__slide', track || root), thumbsEl ? $$('.lx-thumb', thumbsEl) : [], $$('[data-lx-styled] [data-finish]', root)];
      for (const items of groups) {
        const has = items.some((x) => x.dataset.finish === fin);
        items.forEach((x) => { x.hidden = has && !!x.dataset.finish && x.dataset.finish !== fin; });
      }
      const styled = $$('[data-lx-styled] button', root).filter((x) => !x.hidden);
      styled.forEach((x, i) => { x.style.display = i < 4 ? '' : 'none'; });
      if (track) track.scrollTo({ left: 0 });
      syncPosition();
    }
    function update(push) {
      current = data.variants.find((v) => v.o.every((x, i) => x === sel[i]));
      $$('[data-lx-opt]', root).forEach((fs) => { const i = +fs.dataset.lxOpt; const em = $('[data-lx-opt-value]', fs); if (em) em.textContent = sel[i]; $$('input', fs).forEach((inp) => { const t = sel.slice(); t[i] = inp.value; const vv = data.variants.find((v) => v.o.every((x, k) => x === t[k])); inp.classList.toggle('is-unavailable', !vv || !vv.a); }); });
      if (!current) { if (atc) atc.disabled = true; if (atcLabel) atcLabel.textContent = T('unavailable', 'Unavailable'); return; }
      idInput.value = current.id;
      if (atc) atc.disabled = !current.a;
      if (atcLabel) atcLabel.textContent = current.a ? baseLabel : T('sold', 'Sold out');
      const pe = $('[data-lx-price]', root); if (pe) pe.innerHTML = priceHtml(current);
      const sku = $('[data-lx-sku]', root); if (sku) { sku.hidden = !current.sku; const sp = $('span', sku); if (sp) sp.textContent = current.sku || ''; }
      const sv = $('[data-lx-sticky-variant]', root); if (sv) sv.textContent = data.options[0] === 'Title' ? '' : `${current.title} · `;
      const sp = $('[data-lx-sticky-price]', root); if (sp) sp.textContent = money(current.p);
      const si = $('[data-lx-sticky-img]', root); if (si && current.img) { si.removeAttribute('srcset'); si.src = current.img; }
      const bm = $('[data-lx-bundle] [data-main]', root);
      if (bm) { const bp = $('[data-lx-bundle-price]', bm); bp.dataset.lxBundlePrice = current.p; bp.textContent = money(current.p); const t = $('[data-lx-bundle-main-title]', bm); if (t) t.textContent = current.title; }
      if (fi >= 0) {
        filterByFinish(sel[fi]);
        $$('[data-lx-bundle] select[data-lx-bundle-select]', root).forEach((x) => { const o = Array.from(x.options).find((op) => op.text.includes(sel[fi])); if (o) x.value = o.value; });
      }
      const bundle = $('[data-lx-bundle]', root); bundle && bundle._sync && bundle._sync();
      if (push) { const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(history.state, '', u); }
    }
    root.addEventListener('change', (e) => { const fs = e.target.closest('[data-lx-opt]'); if (!fs) return; sel[+fs.dataset.lxOpt] = e.target.value; update(true); });
    // quantity stepper
    root.addEventListener('click', (e) => {
      const st = e.target.closest('[data-lx-step]'); if (!st || !qtyInput) return;
      e.preventDefault();
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(st.dataset.lxStep));
    });
    qtyInput && qtyInput.addEventListener('change', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });
    form && form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current || !current.a) return;
      const q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      atc && atc.classList.add('is-loading');
      try { await add([{ id: current.id, quantity: q }]); } catch (err) {}
      atc && atc.classList.remove('is-loading');
    });
    // sticky bar
    const sticky = $('[data-lx-sticky]', root);
    if (sticky && atc) {
      let ticking = false, state = null;
      const syncSticky = () => { ticking = false; const on = atc.getBoundingClientRect().bottom < 0; if (on === state) return; state = on; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); $('[data-lx-sticky-add]', sticky).tabIndex = on ? 0 : -1; };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); } }, { passive: true });
      syncSticky();
      $('[data-lx-sticky-add]', sticky).addEventListener('click', () => { if (!current) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    }
    if (fi >= 0) filterByFinish(sel[fi]); else syncPosition();
    update(false);
    // recently viewed
    try {
      const key = 'lx-recent'; const list = JSON.parse(localStorage.getItem(key) || '[]').filter((x) => x.handle !== data.handle);
      list.unshift({ handle: data.handle, title: data.title, url: data.url, img: data.image, price: data.price });
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function openZoom(src, alt) { const z = $('[data-lx-zoom]'); if (!z) return; $('[data-lx-zoom-body]', z).innerHTML = `<img src="${esc(src)}" alt="${esc(alt || '')}">`; z.classList.add('is-open'); document.body.classList.add('lx-lock'); }
  function closeZoom() { const z = $('[data-lx-zoom]'); if (!z) return; z.classList.remove('is-open'); if (!openName) document.body.classList.remove('lx-lock'); }
  document.addEventListener('click', (e) => { if (e.target.closest('[data-lx-zoom-close]') || e.target.matches('[data-lx-zoom], [data-lx-zoom] img')) closeZoom(); });
  document.addEventListener('click', (e) => { const z = e.target.closest('[data-lx-zoomable]'); if (z && !e.target.closest('[data-lx-zoom]')) { e.preventDefault(); openZoom(z.dataset.lxZoomable, z.querySelector('img')?.alt); } });

  function recentInit(root) {
    if (root._lx) return; root._lx = true;
    let list = []; try { list = JSON.parse(localStorage.getItem('lx-recent') || '[]'); } catch (e) {}
    const here = $('[data-lx-pdp-json]'); let h = null; try { h = here && JSON.parse(here.textContent).handle; } catch (e) {}
    list = list.filter((x) => x.handle !== h).slice(0, 10);
    if (!list.length) return;
    $('[data-lx-recent-track]', root).innerHTML = list.map((x) => `<div><article class="lx-card"><a class="lx-card__media" href="${esc(x.url)}">${x.img ? `<img src="${esc(imgW(x.img, 500))}" alt="" loading="lazy">` : ''}</a><div class="lx-card__body"><a class="lx-card__title" href="${esc(x.url)}" style="font-size:15px">${esc(x.title)}</a><span class="lx-price">${money(x.price)}</span></div></article></div>`).join('');
    root.hidden = false;
    railInit($('[data-lx-rail]', root));
  }
  async function recosInit(root) {
    if (root._lx) return; root._lx = true;
    try {
      const html = await (await fetch(root.dataset.url)).text();
      const n = $('[data-lx-recos]', parse(html));
      if (n && n.innerHTML.trim()) { root.innerHTML = n.innerHTML; scan(root); }
    } catch (e) {}
  }

  // ------------------------------------------------------------------ rails + tabs
  function railInit(rail) {
    if (!rail || rail._lx) return; rail._lx = true;
    const track = $('[data-lx-track]', rail); if (!track) return;
    const sec = rail.closest('section') || rail.parentElement;
    const bar = $('[data-lx-progress-bar]', rail);
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (bar) { const w = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth)); bar.style.width = w * 100 + '%'; bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 - w) / w) * 100 : 0}%)`; }
      if (!rail.hidden) { const p = $('[data-lx-prev]', sec), n = $('[data-lx-next]', sec); if (p) p.disabled = track.scrollLeft < 8; if (n) n.disabled = track.scrollLeft > max - 8; }
    };
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', debounce(sync, 100));
    rail._sync = sync;
    sync();
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-lx-prev], [data-lx-next]');
    if (b) {
      const sec = b.closest('section'); const rail = $$('[data-lx-rail]', sec).find((r) => !r.hidden); if (!rail) return;
      const t = $('[data-lx-track]', rail); t.scrollBy({ left: (b.hasAttribute('data-lx-next') ? 1 : -1) * t.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    const tab = e.target.closest('[data-lx-tab]');
    if (tab) {
      const root = tab.closest('[data-lx-tabs-root]');
      $$('[data-lx-tab]', root).forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      $$('[data-lx-panel]', root).forEach((p) => { p.hidden = p.dataset.lxPanel !== tab.dataset.lxTab; if (!p.hidden && p._sync) p._sync(); });
      const link = $('[data-lx-tab-link]', root); if (link && tab.dataset.url) link.href = tab.dataset.url;
    }
  });

  // ------------------------------------------------------------------ header + announcement
  function headerInit() {
    const head = $('[data-lx-head]'); if (!head || head._lx) return; head._lx = true;
    const onScroll = () => head.classList.toggle('is-scrolled', window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    const ann = $('[data-lx-ann]');
    if (ann) {
      const msgs = $$('.lx-ann__msg', ann); let i = 0;
      const secs = Number(ann.dataset.speed || 5);
      if (msgs.length > 1) setInterval(() => { if (document.hidden) return; msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, secs * 1000);
    }
  }

  // ------------------------------------------------------------------ predictive search
  function searchInit() {
    const input = $('[data-lx-q]'); if (!input || input._lx) return; input._lx = true;
    const out = $('[data-lx-search-results]'); const idle = $('[data-lx-search-idle]'); const label = $('[data-lx-search-label]');
    const run = debounce(async () => {
      const q = input.value.trim();
      if (!q) { out.innerHTML = ''; idle.hidden = false; label.hidden = true; return; }
      try {
        const res = await fetch(`${LX.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,tag`);
        const json = await res.json();
        const items = (json.resources && json.resources.results && json.resources.results.products) || [];
        idle.hidden = true; label.hidden = false;
        label.textContent = items.length ? T('products', 'Products') : fill(T('noResults', 'No results for “[q]”'), { q });
        out.innerHTML = items.map((p) => `<article class="lx-card"><a class="lx-card__media" href="${esc(p.url)}">${p.image ? `<img src="${esc(imgW(p.image, 500))}" alt="" loading="lazy">` : ''}</a><div class="lx-card__body"><a class="lx-card__title" href="${esc(p.url)}" style="font-size:15px">${esc(p.title)}</a><span class="lx-price">${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ''}</span></div></article>`).join('')
          + (items.length ? `<a class="lx-btn lx-btn--outline" style="grid-column:1/-1;justify-self:start" href="${LX.routes.search}?q=${encodeURIComponent(q)}&type=product">${esc(T('seeResults', 'See all results'))}</a>` : '');
      } catch (e) {}
    }, 220);
    input.addEventListener('input', run);
  }

  // ------------------------------------------------------------------ collection: sort, filters, load more
  function collInit(root) {
    if (root._lx) return; root._lx = true;
    const sectionId = root.closest('.shopify-section')?.id.replace('shopify-section-', '');
    const load = async (url, mode) => {
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      root.style.opacity = '0.6';
      try {
        const html = await (await fetch(u)).text();
        const doc = parse(html); const fresh = $('[data-lx-coll]', doc);
        if (!fresh) { location.href = url; return; }
        if (mode === 'append') {
          const grid = $('[data-lx-grid]', root); $$('[data-lx-grid] > *', fresh).forEach((n) => grid.appendChild(n));
          const more = $('[data-lx-more]', root); const nm = $('[data-lx-more]', fresh);
          if (more) { if (nm) more.replaceWith(nm); else more.remove(); }
        } else {
          closeDrawer();
          root.innerHTML = fresh.innerHTML; root._lx = false; collInit(root);
          const clean = new URL(url, location.origin); clean.searchParams.delete('section_id');
          history.pushState({ lx: true }, '', clean);
          const tb = $('.lx-toolbar', root); if (tb && tb.getBoundingClientRect().top < 0) tb.scrollIntoView();
        }
        scan(root);
      } catch (e) { location.href = url; }
      root.style.opacity = '';
    };
    const sort = $('[data-lx-sort]', root);
    sort && sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); load(u.toString()); });
    const form = $('[data-lx-filter-form]', root);
    const apply = () => { const fd = new FormData(form); const p = new URLSearchParams(); for (const [k, v] of fd) if (v !== '') p.append(k, v); load(`${form.action}?${p.toString()}`); };
    $('[data-lx-filter-apply]', root)?.addEventListener('click', apply);
    form && form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });
    root.addEventListener('click', (e) => {
      const l = e.target.closest('[data-lx-filter-link]'); if (l) { e.preventDefault(); load(l.href); return; }
      const m = e.target.closest('[data-lx-more-link]'); if (m) { e.preventDefault(); m.classList.add('is-loading'); load(m.href, 'append'); }
    });
  }
  window.addEventListener('popstate', (e) => { if (e.state && e.state.lx) location.reload(); });

  // ------------------------------------------------------------------ reveal
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;

  // ------------------------------------------------------------------ boot
  function scan(root = document) {
    $$('[data-lx-pdp]', root).forEach(pdpInit);
    $$('[data-lx-bundle]', root).forEach(bundleInit);
    $$('[data-lx-rail]', root).forEach(railInit);
    $$('[data-lx-coll]', root).forEach(collInit);
    $$('[data-lx-recos]', root).forEach(recosInit);
    $$('[data-lx-recent]', root).forEach(recentInit);
    $$('.lx-reveal:not(.is-in)', root).forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
  }
  LX.scan = scan;
  function boot() { headerInit(); searchInit(); scan(); trimWallets(document); ensureProtect(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { headerInit(); searchInit(); scan(e.target); });
})();
